import {
  AppFolder24Regular,
  AppGeneric24Regular,
  AppsList24Regular,
  ArrowDownload24Regular,
  ArrowNext24Regular,
  ArrowReset24Regular,
  ArrowUpload24Regular,
  ArrowUpRight24Regular,
  CheckboxChecked24Regular,
  CheckboxUnchecked24Regular,
  CheckmarkSquare24Regular,
  ChevronUpDown24Regular,
  CircleSmall24Regular,
  Clock24Regular,
  Copy24Regular,
  Database24Regular,
  DatabaseSearch24Regular,
  DataLine24Regular,
  DismissCircle24Regular,
  DocumentAdd24Regular,
  DocumentArrowDown20Regular, // TODO Why is this missing in 24?
  Earth24Regular,
  Eye24Regular,
  EyeOff24Regular,
  Filter24Regular,
  Flag24Regular,
  Form24Regular,
  FullScreenMaximize24Regular,
  FullScreenMinimize24Regular,
  GroupList24Regular,
  Key24Regular,
  Layer24Regular,
  LocalLanguage24Regular,
  LocationArrowRight20Regular,
  LockClosed24Regular,
  LockMultiple24Regular,
  LockOpen24Regular,
  Merge24Regular,
  MoreHorizontal24Regular,
  MoreVertical24Regular,
  MyLocation24Regular,
  Navigation24Regular,
  Open24Regular,
  People24Regular,
  Person24Regular,
  PersonAdd24Regular,
  PersonFeedback24Regular,
  Pin24Regular,
  QuestionCircle24Regular,
  Ruler24Regular,
  Save24Regular,
  Search24Regular,
  Settings24Regular,
  ShieldProhibited24Regular,
  SignOut24Regular,
  Snooze24Regular,
  Table24Regular,
  TableEdit24Regular,
  Tag24Regular,
  TextBulletListSquare24Regular,
  TextT24Regular,
  WeatherMoon24Filled,
  WeatherMoon24Regular,
  WeatherSunnyHigh24Regular,
  WeatherSunnyLow24Regular,
} from "@fluentui/react-icons";

function Polygon24Regular() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
      <path d="M 5,21 A 3,3 0 0 1 2,18 3,3 0 0 1 4.5761719,15.03125 L 4.8007812,12.998047 4.9335938,11.796875 A 3,3 0 0 1 3,9 3,3 0 0 1 6,6 3,3 0 0 1 8.5175781,7.371094 L 9.3554688,7.091797 12.015625,6.203125 A 3,3 0 0 1 12,6 3,3 0 0 1 15,3 3,3 0 0 1 18,6 3,3 0 0 1 16.863281,8.349609 L 18,10.904297 18.507812,12.044922 A 3,3 0 0 1 19,12 a 3,3 0 0 1 3,3 3,3 0 0 1 -3,3 3,3 0 0 1 -2.677734,-1.660156 L 15.130859,16.595703 7.9960938,18.125 A 3,3 0 0 1 5,21 Z M 5,19.5 A 1.5,1.5 0 0 0 6.5,18 1.5,1.5 0 0 0 5,16.5 1.5,1.5 0 0 0 3.5,18 1.5,1.5 0 0 0 5,19.5 Z m 2.6757812,-2.841797 7.1406248,-1.529297 1.19336,-0.255859 A 3,3 0 0 1 17.136719,12.65625 L 16.628906,11.513672 15.494141,8.957031 A 3,3 0 0 1 15,9 3,3 0 0 1 12.482422,7.628906 L 9.8300781,8.513672 8.984375,8.794922 A 3,3 0 0 1 9,9 3,3 0 0 1 6.4257812,11.96875 l -0.1328124,1.195312 -0.2265626,2.039063 a 3,3 0 0 1 1.609375,1.455078 z M 19,16.5 A 1.5,1.5 0 0 0 20.5,15 1.5,1.5 0 0 0 19,13.5 1.5,1.5 0 0 0 17.5,15 1.5,1.5 0 0 0 19,16.5 Z M 6,10.5 A 1.5,1.5 0 0 0 7.5,9 1.5,1.5 0 0 0 6,7.5 1.5,1.5 0 0 0 4.5,9 1.5,1.5 0 0 0 6,10.5 Z m 9,-3 A 1.5,1.5 0 0 0 16.5,6 1.5,1.5 0 0 0 15,4.5 1.5,1.5 0 0 0 13.5,6 1.5,1.5 0 0 0 15,7.5 Z" />
    </svg>
  );
}

function LineString24Regular() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
      <path d="M 11 4 A 3 3 0 0 0 8 7 A 3 3 0 0 0 10.896484 9.9921875 L 11.193359 11.330078 L 11.638672 13.333984 A 3 3 0 0 0 10.027344 15.615234 L 9.1855469 15.720703 L 7.7890625 15.896484 A 3 3 0 0 0 5 14 A 3 3 0 0 0 2 17 A 3 3 0 0 0 5 20 A 3 3 0 0 0 7.9726562 17.384766 L 9.3710938 17.208984 L 10.21875 17.103516 A 3 3 0 0 0 13 19 A 3 3 0 0 0 16 16 A 3 3 0 0 0 13.101562 13.001953 L 12.658203 11.005859 L 12.359375 9.6660156 A 3 3 0 0 0 13.419922 8.7617188 L 14.763672 9.265625 L 16.019531 9.7363281 A 3 3 0 0 0 16 10 A 3 3 0 0 0 19 13 A 3 3 0 0 0 22 10 A 3 3 0 0 0 19 7 A 3 3 0 0 0 16.582031 8.2382812 L 15.326172 7.7675781 L 13.980469 7.2636719 A 3 3 0 0 0 14 7 A 3 3 0 0 0 11 4 z M 11 5.5 A 1.5 1.5 0 0 1 12.5 7 A 1.5 1.5 0 0 1 11 8.5 A 1.5 1.5 0 0 1 9.5 7 A 1.5 1.5 0 0 1 11 5.5 z M 19 8.5 A 1.5 1.5 0 0 1 20.5 10 A 1.5 1.5 0 0 1 19 11.5 A 1.5 1.5 0 0 1 17.5 10 A 1.5 1.5 0 0 1 19 8.5 z M 13 14.5 A 1.5 1.5 0 0 1 14.5 16 A 1.5 1.5 0 0 1 13 17.5 A 1.5 1.5 0 0 1 11.5 16 A 1.5 1.5 0 0 1 13 14.5 z M 5 15.5 A 1.5 1.5 0 0 1 6.5 17 A 1.5 1.5 0 0 1 5 18.5 A 1.5 1.5 0 0 1 3.5 17 A 1.5 1.5 0 0 1 5 15.5 z " />
    </svg>
  );
}

function MultiPoint24Regular() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
      <path d="M 10 4 A 3 3 0 0 0 7 7 A 3 3 0 0 0 10 10 A 3 3 0 0 0 13 7 A 3 3 0 0 0 10 4 z M 10 5.5 A 1.5 1.5 0 0 1 11.5 7 A 1.5 1.5 0 0 1 10 8.5 A 1.5 1.5 0 0 1 8.5 7 A 1.5 1.5 0 0 1 10 5.5 z M 18 11 A 3 3 0 0 0 15 14 A 3 3 0 0 0 18 17 A 3 3 0 0 0 21 14 A 3 3 0 0 0 18 11 z M 18 12.5 A 1.5 1.5 0 0 1 19.5 14 A 1.5 1.5 0 0 1 18 15.5 A 1.5 1.5 0 0 1 16.5 14 A 1.5 1.5 0 0 1 18 12.5 z M 6 14 A 3 3 0 0 0 3 17 A 3 3 0 0 0 6 20 A 3 3 0 0 0 9 17 A 3 3 0 0 0 6 14 z M 6 15.5 A 1.5 1.5 0 0 1 7.5 17 A 1.5 1.5 0 0 1 6 18.5 A 1.5 1.5 0 0 1 4.5 17 A 1.5 1.5 0 0 1 6 15.5 z " />
    </svg>
  );
}

export const icons = {
  appFolder: <AppFolder24Regular />,
  appGeneric: <AppGeneric24Regular />,
  appsList: <AppsList24Regular />,
  arrowDownload: <ArrowDownload24Regular />,
  arrowNext: <ArrowNext24Regular />,
  arrowReset: <ArrowReset24Regular />,
  arrowUpload: <ArrowUpload24Regular />,
  arrowUpRight: <ArrowUpRight24Regular />,
  asterisk: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="192"
      height="192"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="16"
      viewBox="0 0 256 256"
    >
      <line x1="128" y1="40" x2="128" y2="216"></line>
      <line x1="51.8" y1="84" x2="204.2" y2="172"></line>
      <line x1="51.8" y1="172" x2="204.2" y2="84"></line>
    </svg>
  ),
  checkboxUnchecked: <CheckboxUnchecked24Regular />,
  checkboxChecked: <CheckboxChecked24Regular />,
  checkmarkSquare: <CheckmarkSquare24Regular />,
  circleSmall: <CircleSmall24Regular />,
  copy: <Copy24Regular />,
  clock: <Clock24Regular />,
  database: <Database24Regular />,
  databaseSearch: <DatabaseSearch24Regular />,
  dataLine: <DataLine24Regular />,
  dismissCircle: <DismissCircle24Regular />,
  documentAdd: <DocumentAdd24Regular />,
  documentArrowDown: <DocumentArrowDown20Regular />,
  earth: <Earth24Regular />,
  eye: <Eye24Regular />,
  eyeOff: <EyeOff24Regular />,
  filter: <Filter24Regular />,
  flag: <Flag24Regular />,
  form: <Form24Regular />,
  fullScreenMaximize: <FullScreenMaximize24Regular />,
  fullScreenMinimize: <FullScreenMinimize24Regular />,
  geomLineString: <LineString24Regular />,
  geomMultiLineString: <LineString24Regular />,
  geomMultiPoint: <MultiPoint24Regular />,
  geomMultiPolygon: <Polygon24Regular />,
  geomPoint: <CircleSmall24Regular />,
  geomPolygon: <Polygon24Regular />,
  goToLocation: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C12.3797 2 12.6935 2.28215 12.7432 2.64823L12.75 2.75L12.7491 4.53771C16.2928 4.88757 19.1124 7.70719 19.4632 11.2525L19.5 11.25H21.25C21.6642 11.25 22 11.5858 22 12C22 12.3797 21.7178 12.6935 21.3518 12.7432L21.25 12.75L19.4617 12.749C19.1124 16.2928 16.2928 19.1124 12.7475 19.4632L12.75 19.5V21.25C12.75 21.6642 12.4142 22 12 22C11.6203 22 11.3065 21.7178 11.2568 21.3518L11.25 21.25L11.251 19.4617C7.70719 19.1124 4.88757 16.2928 4.53678 12.7475L4.5 12.75H2.75C2.33579 12.75 2 12.4142 2 12C2 11.6203 2.28215 11.3065 2.64823 11.2568L2.75 11.25L4.53771 11.2509C4.88757 7.70719 7.70719 4.88757 11.2525 4.53678L11.25 4.5V2.75C11.25 2.33579 11.5858 2 12 2ZM12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6Z"
        fill="currentColor"
      />
    </svg>
  ),
  groupList: <GroupList24Regular />,
  help: <QuestionCircle24Regular />,
  key: <Key24Regular />,
  layer: <Layer24Regular />,
  localLanguage: <LocalLanguage24Regular />,
  locationArrow: <LocationArrowRight20Regular />,
  lock: <LockClosed24Regular />,
  lockMultiple: <LockMultiple24Regular />,
  lockOpen: <LockOpen24Regular />,
  merge: <Merge24Regular />,
  moreHorizontal: <MoreHorizontal24Regular />,
  moreVertical: <MoreVertical24Regular />,
  myLocation: <MyLocation24Regular />,
  navigation: <Navigation24Regular />,
  open: <Open24Regular />,
  people: <People24Regular />,
  person: <Person24Regular />,
  personAdd: <PersonAdd24Regular />,
  personFeedback: <PersonFeedback24Regular />,
  pin: <Pin24Regular />,
  ruler: <Ruler24Regular />,
  save: <Save24Regular />,
  search: <Search24Regular />,
  selector: <ChevronUpDown24Regular />,
  settings: <Settings24Regular />,
  shieldProhibited: <ShieldProhibited24Regular />,
  signOut: <SignOut24Regular />,
  snooze: <Snooze24Regular />,
  table: <Table24Regular />,
  tableEdit: <TableEdit24Regular />,
  tag: <Tag24Regular />,
  textBulletListSquare: <TextBulletListSquare24Regular />,
  textT: <TextT24Regular />,
  weatherMoon: <WeatherMoon24Regular />,
  weatherMoonFilled: <WeatherMoon24Filled />,
  weatherSunnyHigh: <WeatherSunnyHigh24Regular />,
  weatherSunnyLow: <WeatherSunnyLow24Regular />,
};
